export enum Breakpoints {
    EXTRA_LARGE = 1440,
    LARGE = 1024,
    MEDIUM = 800,
    SMALL = 568,
    EXTRA_SMALL = 320
}
